import React from "react";

// helpers
import { CURRENCIES_LIST } from "@/globals/currenciesList.constants";


export const CURRENCY_MODAL_DESCRIPTION = (<>
  Hiring space in the EU? Our Concierge Team is on hand to assist! Simply
  start a thread by clicking the mail icon to ask any questions, or talk to us
  directly by clicking the chat icon on the bottom right of your screen.
  <br/>
  Space pricing is based on the currency of the country where the space is located.
  You can select Pounds Sterling (GBP) or Euro (EUR) to display all pricing in
  your preferred currency. If you select a display currency which is different
  to the space’s native currency, the displayed pricing is based on indicative
  FX rates. Changing your display currency does not change your invoice currency -
  you can select your invoice currency when you book the space.
</>
);

export const CURRENCY_TOOLTIP_INFO = "Space pricing is based on the currency of the country where the space is located. " +
    "If you select a display currency which is different to the space currency, the displayed pricing is based on " +
    "indicative FX rates. Changing your display currency does not change your invoice currency - you can select your " +
    "invoice currency when you book the space.";

export const getCurrencySymbol = (currencyCode: string) => {
  if (!currencyCode) {
    return currencyCode;
  }

  const currencySymbol = CURRENCIES_LIST.find(
    (currency) => currency.code === currencyCode
  );

  return currencySymbol ? currencySymbol.symbol : currencyCode;
};

export const currencySymbolToCode = (symbol: string) => {
  const currencyData = CURRENCIES_LIST.find(({ symbol: s }) => s === symbol);

  return currencyData ? currencyData.code : null;
};

/**
 * It takes a number and returns a formatted currency string
 * @param {number | string} value - The value to be formatted.\
 * @param {string} [currencyCode=GBP] - The currency code
 * @param {{ locales: string?, fractDigits: number? }?} options - Formatting options.
 * @returns {string} Formatted currency string.
 */
export const formatCurrency = (
  value: number | string,
  currencyCode: string | null,
  options?: { locales?: string; fractDigits?: number },
) => {
  if (isNaN(Number(value))) {
    return value;
  }

  const currencyDefaultData = CURRENCIES_LIST.find(item => item.code === currencyCode) || {
    locale: "en-GB",
    currencyDisplay: "symbol",
  };

  const { locales = currencyDefaultData.locale, fractDigits = 0 } = options || {};

  try {
    return new Intl.NumberFormat(
      locales, {
        style: "currency",
        currency: currencyCode || "" as string,
        maximumFractionDigits: fractDigits,
        minimumFractionDigits: fractDigits,
        currencyDisplay: currencyDefaultData.currencyDisplay,
      },
    ).format(value as number || 0);
  } catch (e) {
    return value.toString();
  }
};

/**
 * It takes a value and an options object, and returns a formatted currency string
 * @param {number | string} value - The value to be formatted.
 * @param {string} currencySymbol - The currency symbol
 * @param {{ locales: string?, fractDigits: number? }} options - Formatting options.
 * @returns {string} Formatted currency string.
 */
export const formatCurrencyFromSymbol = (value: number | string, currencySymbol = "£", options?: { locales?: string; fractDigits?: number }) => {
  const { locales = "en-US", fractDigits = 0 } = options || {};
  const currencyCode = currencySymbolToCode(currencySymbol);

  return formatCurrency(value, currencyCode, { locales, fractDigits });
};

const currencyUtils = {
  getCurrencySymbol,
  currencySymbolToCode,
  formatCurrency,
  formatCurrencyFromSymbol,
};

export default currencyUtils;
